import React from 'react';
import { Modal } from 'antd';

const LoginModal = ({ visible, onCancel, children }) => {
  return (
    <Modal
      title="用户登录"
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={400}
    >
      {children}
    </Modal>
  );
};

export default LoginModal; 